import { BasketballIncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const InjuryPopup = new PopupBuilder('Injury', {
  incident_id: BasketballIncidentId.Injury,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
